// Auto-generated from version.json — do not edit manually
export const APP_VERSION = '1.0.11';
